import { messageApi } from '@/context/MessageContext';
import { modalApi } from '@/context/ModalContext';
import { findMatchingRoute } from '@/hooks/useCurrentRoute';
import { ApiErrorResponse } from './';

export const loanMonitorHandle = {
  /**
   * 贷后监控没钱，前往充值
   */
  2001: (error: ApiErrorResponse) => {
    modalApi.confirm({
      title: '提示',
      content: error.msg,
      cancelText: '我再想想',
      okText: '马上充值',
      onOk() {
        const path = '/user-center/wallet';
        const matchRoute = findMatchingRoute(path);
        if (matchRoute) {
          location.href = path;
        } else {
          messageApi.warning('暂无菜单权限，请联系管理员');
        }
      },
    });
  },
  /**
   * 贷后监控-已存在监控，请勿重复监控
   */
  2002: (error: ApiErrorResponse) => {
    modalApi.confirm({
      title: '提示',
      content: error.msg,
      okText: '前往详情',
      cancelText: '取消',
      onOk() {
        if (!error.data) return;

        const path = `/monitor/list/detail/${error.data}`;
        const matchRoute = findMatchingRoute(path);
        if (matchRoute) {
          location.href = path;
        } else {
          messageApi.warning('暂无菜单权限，请联系管理员');
        }
      },
    });
  },
};
